import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import React, { useEffect, useState } from 'react';
import InfoTooltipTemplate from '../InfoTooltipTemplate';

/**
 * A customizable dropdown (select) input template
 */
const DropdownInputTemplate = ({
    appendTo="self",
    name,
    label,
    className,
    labelClassName,
    floatLabel,
    noMargins,
    bottomMargin,
    inline,
    value,
    componentValue,
    options,
    placeholder,
    onChangeFunction,
    isValid,
    errorMessage,
    disabled,
    category,
    infoMessage,
    showClear = true,
    filter = false
}) => {
    const [wrapClasses, setWrapClasses] = useState();
    const [inputClasses, setInputClasses] = useState(classNames({
        'p-invalid': isValid,
        'w-full': true
    }));
    const [labelClasses, setLabelClasses] = useState(classNames({
        'p-error': isValid,
        'w-full': true,
        'block mb-2': !inline,
        'mr-2': inline,
        'pr-4': infoMessage
    }));
    const [internalValue, setInternalValue] = useState();

    useEffect(() => {
        // add input classes (if we have any)
        if (className) {
            setInputClasses(inputClasses + ' ' + className);
        }

        // add label classes (if we have any)
        if (labelClassName) {
            setLabelClasses(labelClasses + ' ' + labelClassName);
        }

        // in some cases we will use an internal value (eg: the component is in a datatable row)
        setInternalValue(componentValue);

        // set wrapper classes
        let initialWrapClasses = {
            'mb-5': !noMargins,
            'm-0': noMargins,
            'relative': infoMessage,
            'inline-block': inline
        };

        if (typeof bottomMargin != 'undefined') {
            initialWrapClasses['mb-5'] = false;
            initialWrapClasses['mb-' + bottomMargin] = true;
        }

        setWrapClasses(classNames(initialWrapClasses));
    }, []);

    const inputField = <Dropdown appendTo={appendTo} id={name} value={componentValue || componentValue == 0 ? internalValue : value} options={options} placeholder={placeholder}
        onChange={(e) => {
            if (componentValue || componentValue == 0) {
                setInternalValue(e.target.value);
            }

            onChangeFunction(name, e.target.value, category);
        }}
        className={inputClasses}
        disabled={disabled}
        showClear={showClear}
        filter={filter}
    />;

    return (
        <div className={wrapClasses}>
            {floatLabel
                ? <>
                    <span className="p-float-label">
                        {inputField}
                        <label htmlFor={name} className={labelClasses}>{label}</label>
                        {infoMessage && <div className="top-right-icon">
                            <InfoTooltipTemplate target={'tooltip-' + name} message={infoMessage} className="ml-2" />
                        </div>}
                    </span>

                    {errorMessage}
                </>

                : <>
                    {label && <label htmlFor={name} className={labelClasses} title={ labelClassName == 'one-line' ? label : null }>{label}</label>}
                    {infoMessage && <div className="top-right-icon">
                        <InfoTooltipTemplate target={'tooltip-' + name} message={infoMessage} className="ml-2" />
                    </div>}
                    {inputField}
                    {errorMessage}
                </>
            }
        </div>
    );
};

export default DropdownInputTemplate;
